import { http } from 'lib/services/http';

const DOMAINS_API_PATH = `/notification/email/domains`;
const AUTHENTICATE_INFO_API_PATH = `/notification/email/domains/authentication/domain/`;

const CONTENT_TYPE_NOTIFICATION_V1_0_JSON = {
  'Content-Type': 'application/vnd.nextiva.notification-v1.0+json',
};

/**
 * Swagger for NotificationService, used for email domain stuff:
 * http://10.103.201.30:9010/NotificationService/webjars/swagger-ui/index.html?url=http://10.103.201.30:9010/NotificationService/swagger.json#/
 */

export const getAuthDomainInfo = (domain: string) => {
  return http.get(`${AUTHENTICATE_INFO_API_PATH}/${domain}`);
};

export const addDomain = (email: string) =>
  http.post(
    `${DOMAINS_API_PATH}/verification-request`,
    JSON.stringify({
      email,
      verificationUrl: `${
        window.location.origin
      }/apps/platform-admin/#/email/${encodeURIComponent(email)}`,
    }),
    { headers: { ...CONTENT_TYPE_NOTIFICATION_V1_0_JSON } },
  );

export const getDomains = () => http.get(DOMAINS_API_PATH);

export const verifyDomain = (verificationCode) =>
  http.post(
    `${DOMAINS_API_PATH}/verification`,
    JSON.stringify({ verificationCode }),
    { headers: { ...CONTENT_TYPE_NOTIFICATION_V1_0_JSON } },
  );

export const removeDomain = (domain: string) => {
  return http.delete(`${DOMAINS_API_PATH}/${domain}`, {
    headers: { ...CONTENT_TYPE_NOTIFICATION_V1_0_JSON },
  });
};

export const authenticateDomain = (domain: string) => {
  return http.post(`${DOMAINS_API_PATH}/authentication/validate/${domain}`);
};
